import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[currencyFormat]'
})
export class CurrencyFormatDirective {

  constructor(
    private el: ElementRef,
    private ngControl: NgControl
  ) {}

  @HostListener('input', ['$event'])
  onInput(event: any): void {
    const input = event.target;
    const value = input.value;
    
    // Rimuovi tutto tranne numeri, virgole e trattini/slash per i range
    let cleanValue = value.replace(/[^\d,\-\/\s]/g, '');
    
    // Controlla se è un range
    const isRange = cleanValue.includes('-') || cleanValue.includes('/');
    
    if (isRange) {
      // Gestisce range
      const separator = cleanValue.includes('-') ? '-' : '/';
      const parts = cleanValue.split(separator);
      
      if (parts.length === 2) {
        const formattedParts = parts.map(part => this.formatSingleNumber(part.trim()));
        const formattedValue = formattedParts.join(` ${separator} `);
        this.updateValue(formattedValue);
      }
    } else {
      // Gestisce numero singolo
      const formattedValue = this.formatSingleNumber(cleanValue);
      this.updateValue(formattedValue);
    }
  }

  @HostListener('blur', ['$event'])
  onBlur(event: any): void {
    const value = event.target.value;
    if (!value) return;
    
    // Controlla se è un range
    const isRange = value.includes('-') || value.includes('/');
    
    if (isRange) {
      // Gestisce range
      let separator = '-';
      if (value.includes('/')) {
        separator = '/';
      }
      
      const parts = value.split(separator);
      
      if (parts.length === 2) {
        const formattedParts = parts.map(part =>
          this.formatOnBlurSingle(part.trim())
        );
        const updatedValue = formattedParts.join(` ${separator} `);
        this.updateValue(updatedValue);
      }
    } else {
      // Gestisce numero singolo
      const updatedValue = this.formatOnBlurSingle(value.trim());
      this.updateValue(updatedValue);
    }
  }

  private formatSingleNumber(value: string): string {
    if (!value) return '';
    
    // Rimuovi tutto tranne numeri e virgola
    let cleanNumber = value.replace(/[^\d,]/g, '');

    const parts = cleanNumber.split(',');
    let integerPart = parts[0];
    let decimalPart = parts[1] || '';
    
    // Limita i decimali a 2 cifre
    if (decimalPart.length > 2) {
      decimalPart = decimalPart.substring(0, 2);
    }
    
    // Formatta la parte intera con i punti
    if (integerPart.length > 3) {
      integerPart = this.addThousandsSeparators(integerPart);
    }
    
    // Ricomponi il numero
    return decimalPart.length > 0 ? `${integerPart},${decimalPart}` : integerPart;
  }

  private addThousandsSeparators(value: string): string {
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  private updateValue(formattedValue: string): void {
    this.el.nativeElement.value = formattedValue;
    if (this.ngControl && this.ngControl.control) {
      this.ngControl.control.setValue(formattedValue, { emitEvent: false });
    }
  }

  private formatOnBlurSingle(value: string): string {
    if (!value) return '';

    const clean = value.replace(/[^\d,]/g, '');
    const parts = clean.split(',');
    let integerPart = parts[0] || '';
    let decimalPart = (parts[1] || '').slice(0, 2);

    integerPart = integerPart.replace(/\./g, '');
    if (integerPart.length > 3) {
      integerPart = this.addThousandsSeparators(integerPart);
    }

    if (decimalPart.length < 2) {
      decimalPart = decimalPart.padEnd(2, '0');
    }

    return `${integerPart || '0'},${decimalPart || '00'}`;
  }
}
